import { render, staticRenderFns } from "./listProductsByCategory.vue?vue&type=template&id=6b6ac0cb"
import script from "./listProductsByCategory.vue?vue&type=script&lang=js"
export * from "./listProductsByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports